import { fetchQueryCountApi, fetchQueryListApi} from "../../apis/query.api";
import { fetchRepairAndReplaceListApi } from "../../apis/repair.api";
import { actions, QUERY_STATUS } from "../../utils/constants";
import { callApiAction } from "./commonAction";

export const fetchQueryAction = (filters,queryStatus,repairingStatus,sendStatus, onSuccess = () => { }, onError = () => { }) => {

    return async (dispatch, getState) => {
        dispatch({ type: actions.FETCH_DATA_QUERY_LODING });
        dispatch(callApiAction(
            async () => await fetchRepairAndReplaceListApi({...filters,queryStatus,repairingStatus,sendStatus}),
            (response) => {
                dispatch({
                    type: actions.FETCH_DATA_QUERY_DATA,
                    value: { data: response, filters: filters }
                });
                onSuccess(response);
                // dispatch(fetchQueryCallBack(false))
            },
            (err) => {
                onError(err);
            }
        ))
    }
}

export const fetchQueryCountAction = (filters, onSuccess = () => { }, onError = () => { }) => {
    return async (dispatch, getState) => {
        dispatch({ type: actions.FETCH_DATA_QUERY_COUNT_LODING });
        dispatch(callApiAction(
            async () => await fetchQueryCountApi({queryStatus:QUERY_STATUS.REPAIR}),
            (response) => {
                dispatch({
                    type: actions.FETCH_DATA_QUERY_COUNT_DATA,
                    value: { count: response, filters: filters }
                });
                onSuccess(response);
            },
            (err) => {
                onError(err);
            }
        ))
    }
}

export const fetchQueryCallBack = (data) => {
    return async (dispatch, getState) => {
        dispatch({
            type: actions.FETCH_DATA_QUERY_CALLBACK_DATA,
            value: data
        });
    }
}